import * as swcHelpers from '@swc/helpers';
import { createSelector } from 'reselect';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { Util } from '@grandvisionhq/forms';
import { isDefined } from '@grandvisionhq/utils';
import { isNewPrescriptionAndUpload } from '../../utils/is-new-prescription-upload.js';
import { getIsPupillaryDistanceFileOptional } from '../configurations/selectors.js';
import { getConfiguration } from '../configurations/selectors.internal.js';
import { getAdditionalPrescriptionInfoFormState, getFrameSku } from '../configurator/selectors.js';
import { isBookAppointmentEntrySelection } from '../types.js';

var getAdditionalPrescriptionInfo = createSelector(getAdditionalPrescriptionInfoFormState, (additionalPrescriptionInfoFormState)=>{
    if (!additionalPrescriptionInfoFormState) {
        return {};
    }
    const _ref = Util.getValuesFromState(additionalPrescriptionInfoFormState), { expiryDate  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
        "expiryDate"
    ]);
    return swcHelpers.objectSpread({}, expiryDate ? {
        expiryDate
    } : {}, {
        opticianDetails: swcHelpers.objectSpread({}, rest)
    });
});
/*
 * Utilities for getAddToCartLineItem -----------
 */ const configureBundleLineItemsForCart = (config)=>{
    if (!config) {
        return;
    }
    const bundleLineItems = [];
    Object.keys(config).forEach((item)=>{
        var ref;
        let sku;
        if (item === 'prescriptionType' || !config[item]) {
            return;
        }
        if (item === 'lensType' && (config === null || config === void 0 ? void 0 : (ref = config.lensType) === null || ref === void 0 ? void 0 : ref.sku)) {
            sku = config.lensType.sku;
        }
        bundleLineItems.push({
            sku: sku !== null && sku !== void 0 ? sku : config[item]
        });
    });
    return bundleLineItems;
};
const configurePrescriptionInfo = (config, additionalInfo, isPrescriptionRecognitionEnabled, isPDFileOptional)=>{
    var ref;
    const prescriptionType = config === null || config === void 0 ? void 0 : config.prescriptionType;
    if (!prescriptionType || isBookAppointmentEntrySelection(prescriptionType)) {
        return;
    }
    if (CommerceToolsApi.isEmailPrescription(prescriptionType)) {
        return {
            type: 'email-prescription'
        };
    }
    if (CommerceToolsApi.isExistingCustomer(prescriptionType)) {
        return {
            type: 'existing-customer'
        };
    }
    const prescriptionInfo = config === null || config === void 0 ? void 0 : (ref = config.lensType) === null || ref === void 0 ? void 0 : ref.prescriptionInfo;
    if (CommerceToolsApi.isNewPrescription(prescriptionType)) {
        if (!prescriptionInfo) {
            return;
        }
        const { right , left  } = prescriptionInfo;
        return {
            type: 'new-prescription',
            details: swcHelpers.objectSpread({
                rightLens: right,
                leftLens: left
            }, additionalInfo)
        };
    }
    if (CommerceToolsApi.isPrescriptionFile(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType)) {
        var ref1;
        const uploadReferences = prescriptionInfo === null || prescriptionInfo === void 0 ? void 0 : prescriptionInfo.uploadReferences;
        const hasPupillaryDistancePrescriptionInfo = isDefined(prescriptionInfo === null || prescriptionInfo === void 0 ? void 0 : prescriptionInfo.left.pupillaryDistance) && isDefined(prescriptionInfo === null || prescriptionInfo === void 0 ? void 0 : (ref1 = prescriptionInfo.right) === null || ref1 === void 0 ? void 0 : ref1.pupillaryDistance);
        const isPDInputValid = (uploadReferences === null || uploadReferences === void 0 ? void 0 : uploadReferences['pg-pupillary-distance']) || isPDFileOptional && hasPupillaryDistancePrescriptionInfo;
        if (!uploadReferences || !uploadReferences['pg-prescription'] || !isPDInputValid) {
            return;
        }
        const lensInfo = {};
        if (prescriptionInfo && (isPrescriptionRecognitionEnabled || isNewPrescriptionAndUpload(prescriptionType))) {
            const { right , left  } = prescriptionInfo;
            lensInfo.left = left;
            lensInfo.right = right;
        }
        return {
            type: 'prescription-file',
            details: swcHelpers.objectSpread({
                prescriptionFile: uploadReferences['pg-prescription'],
                pupillaryDistanceFile: uploadReferences['pg-pupillary-distance']
            }, lensInfo)
        };
    }
};
/*
 * end Utility functions for getAddToCartLineItem -----------
 */ /*
 * Get a line item configured to be added to cart.
 */ const getAddToCartLineItem = (isPrescriptionRecognitionEnabled)=>createSelector(getFrameSku, (s)=>s
    , getIsPupillaryDistanceFileOptional, (frameSku, state, isPDFileOptional)=>{
        if (!frameSku) {
            return undefined;
        }
        const lineItemRawConfig = getConfiguration(state, {
            frameSku
        });
        const additionalPrescriptionInfo = getAdditionalPrescriptionInfo(state);
        const bundleLineItems = configureBundleLineItemsForCart(lineItemRawConfig);
        const prescription = configurePrescriptionInfo(lineItemRawConfig, additionalPrescriptionInfo, isPrescriptionRecognitionEnabled, isPDFileOptional);
        if (!bundleLineItems || !prescription) {
            return undefined;
        }
        return {
            type: 'prescription-glasses',
            sku: frameSku,
            bundleLineItems,
            prescription
        };
    })
;

export { getAddToCartLineItem, getAdditionalPrescriptionInfo };
//# sourceMappingURL=selectors.js.map
